import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import { ECLIPSE_BG } from '@wix/package-picker-shared-eclipse';
import React from 'react';
import { AllPlansIncludeSkeleton } from '../AllPlansIncludedFeaturesBanner/AllPlansIncludeSkeleton';
import { Background } from '../Background';
import { ProductCardsSkeleton } from '../ProductCards/ProductCardsSkeleton/ProductCardsSkeleton';

export interface PlansSectionSkeletonProps {
  /** Number of feature items in the all-plans-included banner skeleton. Defaults to 4. */
  allPlansIncludeItems?: number;
  /** Number of product cards in the skeleton. Defaults to 4. */
  numCards?: number;
  dataHook?: string;
}

export const PlansSectionSkeleton = ({
  allPlansIncludeItems = 4,
  numCards = 4,
}: PlansSectionSkeletonProps) => {
  return (
    <Background backgroundColor={ECLIPSE_BG}>
      <SkeletonGroup>
        <Box align="center" width="100%" textAlign="center" marginBottom="29px">
          <SkeletonRectangle height="30px" width="492px" />
        </Box>
        <Box width="100%" marginTop="SP3" align="center">
          <AllPlansIncludeSkeleton numItems={allPlansIncludeItems} />
        </Box>
        <Box marginTop="SP7" marginLeft="SP3" marginRight="SP3">
          <ProductCardsSkeleton numCards={numCards} />
        </Box>
      </SkeletonGroup>
    </Background>
  );
};
